import { useQuery } from "@tanstack/react-query";
import type { ProviderType } from "@wags/catalog/pure.ts";
import { providerPageToProfileV2 } from "./profile/from-provider-page";
import type { ProviderProfileV2 } from "./profile/types";
import { getProvider } from "./provider";

export async function fetchProviderPage(providerId: string) {
    return getProvider({ data: providerId });
}

export function useProviderProfileV2(
    providerId: string | undefined,
    providerType: ProviderType | undefined,
    enabled: boolean,
): ProviderProfileV2 | null {
    const { data } = useQuery({
        queryKey: ["provider-profile-v2", providerId],
        enabled:
            enabled && providerId !== undefined && providerType !== undefined,
        queryFn: () => fetchProviderPage(providerId ?? ""),
        select: (page) => (page ? providerPageToProfileV2(page) : null),
        staleTime: 5 * 60 * 1000,
        retry: false,
    });
    return data ?? null;
}
